import { queryBuilder } from '@contember-cloud/studio-client';
export const CHAPTER_FRAGMENT = queryBuilder.fragment('SpecificationChapter', it => it.$('id').$('type').$('content'));
export const ProjectWithChapters = queryBuilder.fragment('Project', it => it
    .$$()
    .$('specification', it => it.$$().$('chapters', CHAPTER_FRAGMENT))
    .$('schema', it => it.$('id').$('dsl').$('schema'))
    .$('structure', it => it.$('id').$('dsl').$('crudDsl'))
    .$('workflows', it => it.$('id').$('content'))
    .$('repository', it => it.$$())
    .$('cloudProject', it => it.$$()));
export const queryGetProject = (uniqueQueryInput) => {
    return queryBuilder.get('Project', uniqueQueryInput, ProjectWithChapters);
};
//# sourceMappingURL=queryGetProject.js.map